"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getImagePos(images, currentPos, move) {
  if (move === "next") {
    var newIndex = currentPos + 1;
    if (currentPos === images.length - 1) {
      newIndex = 0;
    }
    return newIndex;
  } else if (move === "prev") {
    var _newIndex = currentPos - 1;
    if (_newIndex <= -1) {
      _newIndex = images.length - 1;
    }
    return _newIndex;
  }
  return 0;
}
var _default = getImagePos;
exports.default = _default;